import { Orientation } from '../types'

/**
 * Get a shorthand to conditionally apply classes based on orientation
 * @param orientation - layout orientation
 * @returns { l: true if orientation is 'landscape', lp: true if orientation is 'landscape' or 'portrait', etc. }
 */
export const useOrientation = (orientation: Orientation) => {
  return {
    l: orientation === 'landscape',
    lp: orientation === 'landscape' || orientation === 'portrait',
    ls: orientation === 'landscape' || orientation === 'square',
    p: orientation === 'portrait',
    pl: orientation === 'portrait' || orientation === 'landscape',
    ps: orientation === 'portrait' || orientation === 'square',
    s: orientation === 'square',
    sl: orientation === 'square' || orientation === 'landscape',
    sp: orientation === 'square' || orientation === 'portrait',
  }
}
